<mat-toolbar class="header-layout">
  <span role="img" alt="Bask Bank Logo" aria-label="Bask Bank Logo" class="logo"></span>
  <app-debug-info *ngIf="debugVisible && (isDesktopView$ | async)"></app-debug-info>
  <span class="spacer"></span>
  <app-information-security></app-information-security>
</mat-toolbar>
